import { apiPlugin, storyblokInit } from "@storyblok/react/rsc";

import Page from "@/components/Page";
import Hero from "@/components/Hero";
import Section from "@/components/Section";
import Button from "@/components/Button";
import EventGrid from "@/components/EventGrid";
import Cta from "@/components/Cta";
import Carousel from "@/components/Carousel";
import Card from "@/components/Card";
import IconBlockGrid from "@/components/IconBlockGrid";
import IconBlock from "@/components/IconBlock";
import ContactGrid from "@/components/ContactGrid";
import Container from "@/components/Container";
import FaqAccordion from "@/components/FaqAccordion";
import RichText from "@/components/RichText";
import GenericGrid from "@/components/GenericGrid";
import ContactForm from "@/components/ContactForm";
import Form from "@/components/Form";

export const getStoryblokApi = storyblokInit({
  // Server only: the preview token reads drafts and is not sent to the browser
  // (no NEXT_PUBLIC_). There this file is loaded for the component list alone —
  // the editor's live update goes through a server action, not the API.
  accessToken: process.env.STORYBLOK_PREVIEW_TOKEN,
  use: process.env.STORYBLOK_PREVIEW_TOKEN ? [apiPlugin] : [],
  components: {
    page: Page,
    hero: Hero,
    section: Section,
    button: Button,
    event_grid: EventGrid,
    cta: Cta,
    carousel: Carousel,
    card: Card,
    icon_block_grid: IconBlockGrid,
    icon_block: IconBlock,
    contact_grid: ContactGrid,
    container: Container,
    faq: FaqAccordion,
    blog_entry: Page,
    text: RichText,
    grid: GenericGrid,
    contact_form: ContactForm,
    form: Form,
    form_field: () => null,
    // Config content types — rendered via layout, no page-level output needed
    header: () => null,
    footer: () => null,
    common: () => null,
    // Entry/data types without a dedicated page template
    job: () => null,
    event: () => null,
    event_booking: () => null,
    faq_entry: () => null,
    games: () => null,
    opening_hour: () => null,
    partner: () => null,
    product: () => null,
    reservation: () => null,
    team: () => null,
    blog_grid: () => null,
  },
});